module.exports = __webpack_public_path__ + "img/WaterGoldTitle.986ec626.png";